export default __webpack_public_path__ + "static/media/notification.01df7b17.svg";